import TableSkeleton from '../../../components/loaders/TableSkeleton';
import ListHeader from '../../../components/ListHeader';
import { useTranslation } from 'react-i18next';
import FuelTypesTableContainer from '../../../modules/fuelTypes/components/FuelTypesTableContainer';
import useModuleTableHelpers from '../../../hooks/useModuleTableHelpers';
import Button from '../../../components/buttons/Button';
import { hasPermission } from '../../../utils/HelperFunctions';

const FuelTypes = () => {
  const { t } = useTranslation();

  const { apiData, apiDataLoading, paginationEle } = useModuleTableHelpers({
    route: 'admin/fuel-types',
    withBreadcrumb: true,
    breadcrumbTitle: t('links.fuel_types'),
    withPagination: true,
    queryKey: 'fuel-types'
  });

  const tableHeaders = [
    { label: t('code') },
    { label: t('name_en') },
    { label: t('name_ar') },
    hasPermission(['fuel_types.edit']) && { label: t('actions'), customClass: 'actions_col' }
  ];

  if (apiDataLoading) return <TableSkeleton columns={6} withoutButton />;

  return (
    <div className="fuelTypes-page-container">
      <ListHeader customClass='table_filters'>
        {hasPermission(['fuel_types.edit']) && <Button text={t('create_fuel_type')} link="/fuel-types/create-fuel-type" />}
      </ListHeader>
      <FuelTypesTableContainer tableHeaders={tableHeaders} data={apiData} noDataMessage={t('no_fuel_types_found')} lessColumns />
      {paginationEle}
    </div>
  );
};

export default FuelTypes;
